import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import ContainerHome from "../components/ContainerHome";
import "../styles/login.css";
import { AuthContext } from "../store/AuthContext";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";


import { Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import Meta from "../components/Meta";

const LoginScreen = ({ location }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // eslint-disable-next-line
  const redirect = location.search ? location.search.split("=")[1] : "/";
  const { handleLogin } = useContext(AuthContext);
  const [isVerified, setIsVerified] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    handleLogin(email, password);
  };

  function onChange(value) {
    if (value === null) {
      setIsVerified(false);
    } else {
      setIsVerified(true);
    }
  }

  return (
    <>
      <ToastContainer />
      <Meta/>
      <ContainerHome>
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 text-gray-900 mb-4">
                        Carteira Virtual - SESC/AL
                      </h1>
                    </div>

                    {/* FORMULÁRIO DE LOGIN  */}

                    <form className="user" onSubmit={submitHandler}>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control form-control-user"
                          aria-describedby="emailHelp"
                          placeholder="Entre com email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control form-control-user"
                          placeholder="Entre com senha"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>

                      <Button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                        disabled={!isVerified}
                      >
                        Entrar
                      </Button>

                      <hr />
                    </form>

                    <div className="text-center">
                      <ReCAPTCHA
                        sitekey={process.env.REACT_APP_RECAPTCHA}
                        onChange={onChange}
                      />

                      <Link to={"/forgot-password"} className="small">
                        Esqueceu a senha?
                      </Link>
                    </div>
                    <div className="text-center">
                      <Link to={"/register"} className="small">
                        Criar uma conta!
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContainerHome>
    </>
  );
};

export default LoginScreen;
